import {useQuery, type UseQueryResult} from '@tanstack/react-query';
import userFetchers from '@/api/fetchers/user';
import {
  PaidGigsCountersResponseSchema,
  type PaidGigsCounters,
} from '@/schema/PaidGigsCounters';

export type UseUserPaidGigsCountersQueryResult =
  UseQueryResult<PaidGigsCounters>;

export type UseUserPaidGigsCountersQueryOptions = {
  enabled?: boolean;
};

const useUserPaidGigsCountersQuery = ({
  enabled = true,
}: UseUserPaidGigsCountersQueryOptions = {}): UseUserPaidGigsCountersQueryResult => {
  return useQuery<PaidGigsCounters>({
    queryKey: ['user/paid_gigs/creator_paid_gigs_counters'],
    queryFn: async () => {
      const response = await userFetchers.paidGigsCounters();
      return PaidGigsCountersResponseSchema.parse(response).data;
    },
    enabled,
  });
};

export default useUserPaidGigsCountersQuery;
